// Reseller / storefront configuration, read once from build-time env.
// When resellerMode is false (the default) none of this affects the app — it
// behaves as the normal consumer player.

const env = import.meta.env;

export const branding = {
  /** Master switch for guest-browsing storefront behavior. */
  resellerMode: env.VITE_RESELLER_MODE === 'true',
  brandName: (env.VITE_BRAND_NAME as string) || 'RedHood IPTV',
  brandLogo: (env.VITE_BRAND_LOGO as string) || '/hero-image.jpeg',
  brandAccent: (env.VITE_BRAND_ACCENT as string) || '#ef4444',
  subscribeUrl: (env.VITE_SUBSCRIBE_URL as string) || '',
  /** PIN gate for the operator/admin panel. Override via env; change in production. */
  adminPin: (env.VITE_ADMIN_PIN as string) || '1234',
  /** Demo/master line used ONLY to fetch catalog metadata for guest browsing. */
  showcase: {
    username: (env.VITE_SHOWCASE_USERNAME as string) || '',
    password: (env.VITE_SHOWCASE_PASSWORD as string) || '',
  },
};

/** True when a showcase line is configured (required for guest browsing). */
export const hasShowcaseCreds = Boolean(
  branding.showcase.username && branding.showcase.password
);
